module.exports = __webpack_public_path__ + "img/1450739158.39435856.jpg";